import React from 'react'
import {useStore} from 'react-hookstore'
import {listingsTxt} from './listingsTxt'

export function ListingItem({atype,index}) {
  const [, setModal] = useStore('modal')
  const [lang] = useStore('language')
  const label = listingsTxt[atype][index].label
  const txt = listingsTxt[atype][index].txt
  const date = listingsTxt[atype][index].date

  const clickme = () => {
    setModal(modal => ({...modal, label:label, open:'modal-open',
                        title:txt[lang]}))
    document.body.style.overflow = 'hidden'
  }
  return(
    <div>
      <div className="listing" onClick={clickme}>{txt[lang]}</div>
      <div className='date'>{date[lang]}</div>
      <hr/>
    </div>
  )
}
